var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrap},[(_vm.hasFrame)?_c('FntAdvLabelFrame',{attrs:{"width":"64","height":"8"}}):_vm._e(),(!_vm.hasFrame)?_c('FntAdvLabel',{attrs:{"width":"44","height":"12"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }